import EditablePropsType from '../../../types/composer';

export const titleSchema = {
  type: EditablePropsType.Text,
  label: 'Title',
  name: 'title',
};

export default titleSchema;
